import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { FormsModule } from '@angular/forms';
import { ModalModule } from 'ngx-bootstrap/modal';
import { CompanyPageDeleteCompanyContactModalComponent } from './company-page-delete-company-contact-modal.component';

@NgModule({
  declarations: [CompanyPageDeleteCompanyContactModalComponent],
  imports: [
    CommonModule,
    FormsModule,
    ModalModule.forRoot()
  ],
  exports: [CompanyPageDeleteCompanyContactModalComponent],
  entryComponents: [CompanyPageDeleteCompanyContactModalComponent]
})
export class CompanyPageDeleteCompanyContactModalModule { }
